module.exports = __webpack_public_path__ + "static/media/chevron-up-blue.b65e3b67.svg";